import React from 'react';
import paths, { rootPaths } from './paths';
import { createBrowserRouter } from 'react-router-dom';

import AdminLayout from '../layouts/AdminLayout';
import MainLayout from '../layouts/MainLayout';
//import ErrorLayout from '../layouts/ErrorLayout';
//import Error404 from '../components/ErrorPages/Error404';
//import Error500 from '../components/ErrorPages/Error500';
import AdminDashboard from '../components/Admin/Dashboard/Dashboard';
import AdminUsers from '../components/Admin/Users/Users';
import SellerSarees from '../components/Admin/Products/SellerSarees';
import SellerKurtis from '../components/Admin/Products/SellerKurtis';
import UserDashboard from '../components/User/Dashboard/Dashboard';
import UserProfiles from '../components/User/Profiles/Profiles';
import UserOrders from '../components/User/Orders/Orders';
import UserAddresses from '../components/User/Addresses/Addresses';
import UserWishlist from '../components/User/Wishlist/Wishlist';
//import Home from '../components/Home/Home' 
import Products from '../components/Products/Products'; 
import ProductDetails from '../components/Products/ProductDetails';
import Checkout from '../components/Checkout/Checkout';
import Success from '../components/Checkout/Success';
import SubCategories from '../components/Products/SubCategories';
import HotDeals from '../components/Products/HotDeals';
import TrackOrder from '../components/Products/TrackOrder';
import PrivacyPolicy from '../components/Home/PrivacyPolicy';
import ContactUs from '../components/Home/ContactUs';
import ShippingPolicy from '../components/Home/ShippingPolicy';
import ReturnExchangePolicy from '../components/Home/ReturnExchangePolicy';
import TermsConditions from '../components/Home/TermsConditions';
import WomenKurtasKurtis from '../components/Womens/KurtasKurtis';
const routes = [
  {
    // element: <App />,
    children: [
      // {
      //   path: '/',
      //   element: <MainLayout />,
      // },
      // {
      //   path: rootPaths.errorsRoot,
      //   element: <ErrorLayout />,
      //   children: [
      //     {
      //       path: paths.error404,
      //       element: <Error404 />
      //     },
      //     {
      //       path: paths.error500,
      //       element: <Error500 />
      //     }
      //   ]
      // },
       
      {
        path: rootPaths.adminRoot,
        element: <AdminLayout />,
        children: [
          {
            path: paths.adminDashboard,
            element: <AdminDashboard />
          },
          {
            path: paths.adminUsers,
            element: <AdminUsers />
          } ,
          
          {
            path: paths.sellerSarees,
            element: <SellerSarees />
          },
        ]
      },
      {
        path: rootPaths.userRoot,
        element: <MainLayout />,
        children: [
          {
            path: paths.userDashboard,
            element: <UserDashboard />
          },
          {
            path: paths.userProfile,
            element: <UserProfiles />
          },
          {
            path: paths.userOrders,
            element: <UserOrders />
          },
          {
            path: paths.userAddresses,
            element: <UserAddresses />
          }
        ]
      },
      {
        path: rootPaths.root,
        element: <MainLayout />,
        children: [
          {
            path: paths.home,
            //element: <Home />   // please change here for root component. currently landing page is products component
            element: <Products />
          },  
          {
            path: paths.store,
            element: <Products />
          },  
          {
            path: paths.womenKurtasKurtis,
            element: <WomenKurtasKurtis />
          },
          {
            path: paths.subCategories(':categoryId'),
            element: <SubCategories />
          },
          {
            path: paths.productDetails(':productId'),
            element: <ProductDetails />
          },
          {
            path: paths.offers,
            element: <HotDeals />
          },
          {
            path: paths.tracking,
            element: <TrackOrder />
          },{
            path: paths.privacyPolicy,
            element: <PrivacyPolicy />
          },{
            path: paths.contactUs,
            element: <ContactUs />
          },{
            path: paths.shippingPolicy,
            element: <ShippingPolicy />
          },{
            path: paths.returnExchangePolicy,
            element: <ReturnExchangePolicy />
          },{
            path: paths.termsConditions,
            element: <TermsConditions />
          }, 
          {
            path: paths.userWishlist,
            element: <UserWishlist />
          },
          {
            path: paths.checkout,
            element: <Checkout />
          },
          {
            path: paths.payment_success,
            element: <Success />
          }
          
        ]
      },
      // {
      //   path: '*',
      //   element: <Navigate to={paths.error404} replace />
      // }
    ]
  }
];

export const router = createBrowserRouter(routes, {
  basename: process.env.PUBLIC_URL
});

export default routes;
